import { ArrowUpRight, Instagram, Mail, Phone } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const goSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      window.setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 120);
      return;
    }
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="relative overflow-hidden bg-[#06101E] text-[#F5F5F5]" data-testid="site-footer">
      <div className="blueprint-grid-dark absolute inset-0 opacity-70" />
      <div className="absolute -right-32 -top-32 h-96 w-96 rounded-full border border-[#C5A880]/20" />
      <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="mb-14 grid gap-10 lg:grid-cols-[1.4fr_0.8fr_0.8fr]">
          <div>
            <img src="https://customer-assets.emergentagent.com/job_plotted-homes-india/artifacts/e6z3ucbf_Next%20Leap%20-%20Print.png" alt="Next Leap Inc" className="mb-6 h-16 w-auto bg-[#F5F5F5] p-2" />
            <p className="max-w-lg font-display text-3xl leading-tight text-[#F5F5F5] sm:text-4xl">
              Turning carefully chosen land into decisive generational leaps.
            </p>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-[#F5F5F5]/60">
              Mandate-led plotted developments and residential projects across India, guided personally by Vikrant Pawar and Bhagwandas Kewat.
            </p>
          </div>

          <div>
            <h3 className="mb-5 font-tech text-xs uppercase tracking-[0.25em] text-[#C5A880]">Navigation</h3>
            <div className="grid gap-3 text-sm text-[#F5F5F5]/70">
              <button className="text-left transition-colors hover:text-[#C5A880]" onClick={() => goSection('about')} data-testid="footer-about-link">Philosophy</button>
              <Link to="/projects" className="transition-colors hover:text-[#C5A880]" data-testid="footer-projects-link">11 live mandates</Link>
              <button className="text-left transition-colors hover:text-[#C5A880]" onClick={() => goSection('services')} data-testid="footer-services-link">Sales engine</button>
              <Link to="/admin" className="transition-colors hover:text-[#C5A880]" data-testid="footer-admin-link">Mandate operations</Link>
            </div>
          </div>

          <div>
            <h3 className="mb-5 font-tech text-xs uppercase tracking-[0.25em] text-[#C5A880]">Direct line</h3>
            <div className="grid gap-3 text-sm">
              <a href="tel:+917039310297" className="group flex items-center gap-3 text-[#F5F5F5]/80 transition-colors hover:text-white" data-testid="footer-phone-link"><Phone className="h-4 w-4 text-[#C5A880]" />+91 70393 10297</a>
              <a href="mailto:vikrant.pawar@nextleapinc.com" className="group flex items-center gap-3 break-all text-[#F5F5F5]/80 transition-colors hover:text-white" data-testid="footer-email-link"><Mail className="h-4 w-4 shrink-0 text-[#C5A880]" />vikrant.pawar@nextleapinc.com</a>
              <a href="https://www.instagram.com/nextlead_inc?igsi=cHFpdGRscTl2eWQ1" target="_blank" rel="noreferrer" className="group flex items-center gap-3 text-[#F5F5F5]/80 transition-colors hover:text-white" data-testid="footer-instagram-link"><Instagram className="h-4 w-4 text-[#C5A880]" />@nextlead_inc<ArrowUpRight className="h-3 w-3" /></a>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 border-t border-white/10 pt-8 font-tech text-[11px] uppercase tracking-[0.18em] text-[#F5F5F5]/50 md:flex-row md:items-center md:justify-between">
          <span>© {new Date().getFullYear()} Next Leap Inc</span>
          <span>Directors · Vikrant Pawar / Bhagwandas Kewat</span>
          <span>Mumbai · Goa · Nagpur · Vrindavan</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
